import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoanInfoService } from '@app/core/services/loan-info.service';
import { UnityDirectStateService } from '@app/core/services/unity-direct-state.service';
import { LoanStatus } from '@app/models/Loan-Status';
import { loanStatusText } from '@app/shared/constants/loanStatusText';
import { changePortalHeaderWidth } from '@app/shared/utils/utility';
import { Subject } from 'rxjs';
import { map, pairwise, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss']
})
export class HeaderBarComponent implements OnInit, OnDestroy {
  loanStatus: string;
  loanDetails$: any;
  isISAOpen: boolean = false;
  onDestroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public loanInfo: LoanInfoService,
    public udStateService: UnityDirectStateService
  ) {}

  get isShowEstimatedMonthlyPayment(): boolean {
    return this.udStateService.isShowEstimatedMonthlyPayment;
  }

  getMonthlyPaymentValue(): number {
    return this.udStateService.monthlyPayment || 0;
  }

  getTextForLoanStatus(loanStatus: string): string {
    return loanStatusText[loanStatus];
  }

  ngOnInit(): void {
    this.isISAOpen = false;
    this.udStateService.loanStatusSubject
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(status => {
        this.loanStatus =
          this.getTextForLoanStatus(status) ||
          this.getTextForLoanStatus(LoanStatus.New);
      });
    this.loanDetails$ = this.loanInfo.loanInfo$.pipe(
      startWith(null),
      pairwise(),
      map(([previousValue, currentValue]) => {
        this.udStateService.loanStatusSubject.next(currentValue.loanStatus);
        return { ...previousValue, ...currentValue };
      })
    );

    this.subscribeToISAState();
  }

  /**
   * Subscribes to open/close state of ISA and changes width accordingly
   */
  subscribeToISAState(): void {
    this.udStateService.isaOpenSubject
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((isOpen: boolean) => {
        this.isISAOpen = isOpen;
        changePortalHeaderWidth(this.isISAOpen);
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
